import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Spin,
  Form,
  Col,
  Card,
  Input,
  Button,
  message,
  DatePicker,
} from 'antd';
import Table from 'components/Table';
import {
  deletePanteon,
  getPanteon,
  getPanteones,
  patchPanteon,
  postPanteon,
  baseURI,
} from 'api/empresas/panteones';
import { DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitControls';
import Select from 'components/Select';
import { useSelector } from 'react-redux';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { InputSearchPro } from 'components/InputSearch';
import ModalDelete from 'components/ModalDelete';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { patchCiudadano } from 'api/cuentaunicasir/ciudadanos';
import { onError } from 'utils/handlers';
import { getContribuyenteCaja, getContribuyente } from 'api/empresas/contribuyentes';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import { DATETIME_FRONTEND_FORMAT } from 'utils/formatValues';
import { isMutable } from 'utils/estadosGlobales';
import {
  getTiposDeContratos,
  getTiposDeEspacios,
  getTiposDePanteones,
} from 'api/recaudacion/index';
import { getCiudadano } from 'api/cuentaunicasir';
import { capitalize } from 'utils/normalizers';
// import { getModelPermission } from 'utils/permission';
import padronToString from 'utils/padronesToString';
// import Difuntos from './Difuntos';

const initialStates = Object.freeze({
  data: [],
  visible: false,
  loading: true,
  selectedRowKeys: [],
  currentPage: 1,
  visibleAlert: false,
  mutable: true,
  isCiudadano: false,
  visibleBusquedaPadrones: false,
});

export const catalosgModels = [
  'tipodepanteon',
  'tipodecontratopanteon',
  'tipoespaciopanteon',
  'tipolotedepanteon',
];

// eslint-disable-next-line react/prop-types
const Panteones = ({ permission }) => {
  const {
    estadosGlobales,
    padrones,
  } = useSelector((state) => state.catalogs);

  const { entidad: _entidad } = useSelector((state) => state.auth);
  // const permissionsDifuntos = getModelPermission('difunto');

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [data, setData] = useState(initialStates.data);
  const [visible, setVisible] = useState(initialStates.visible);
  const [loading, setLoading] = useState(initialStates.loading);
  const [selectedRowKeys, setSelectedRowKeys] = useState(initialStates.selectedRowKeys);
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleAlert, setVisibleAlert] = useState(initialStates.visibleAlert);
  const [mutable, setMutable] = useState(initialStates.mutable);
  const [isCiudadano, setIsCiudadano] = useState(false);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  const [ciudadanoFound, setCiudadanoFound] = useState([]);
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const [dataExterno, setDataExterno] = useState({ count: 0, results: [] });
  // const [current, setCurrent] = useState(null);
  const searchRef = useRef();

  // catalogs
  const [tiposDePanteones, setTiposDePanteones] = useState([]);
  const [tiposDeContratos, setTiposDeContratos] = useState([]);
  const [tiposDeEspacios, setTiposDeEspacios] = useState([]);

  const onCancel = () => {
    setCiudadanoFound([]);
    setContribuyenteFound([]);
    // setCurrent(null);
    setSelectedRowKeys([]);
    setVisible(initialStates.visible);
    form.resetFields();
  };

  const fetchData = async (page = 1, q = null) => {
    setCurrentPage(page);
    setLoading(true);
    const _data = await getPanteones({ ...q, page });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let isMounted = true;
    const fetchAll = async () => {
      const [
        _tiposDePanteones,
        _tiposDeContratos,
        _tiposDeEspacios,
      ] = await Promise.all([
        getTiposDePanteones(),
        getTiposDeContratos(),
        getTiposDeEspacios(),
      ]);

      if (isMounted) {
        setTiposDeEspacios(_tiposDeEspacios);
        setTiposDeContratos(_tiposDeContratos);
        setTiposDePanteones(_tiposDePanteones);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { isMounted = false; };
  }, []);

  const columns = [
    {
      titleText: 'Clave ',
      dataIndex: 'folio',
      key: 'folio',
      width: 150,
    },
    {
      titleText: 'Contribuyente',
      dataIndex: 'contributente',
      key: 'contributente',
      width: 300,
      render: (value) => value?.nombre_completo ?? 'N/A',
    },
    {
      titleText: 'Panteón',
      dataIndex: 'panteon',
      key: 'panteon',
      width: 150,
      render: (value) => tiposDePanteones.find((panteon) => panteon.id === value)?.descripcion,
    },
    {
      titleText: 'Contrato',
      dataIndex: 'tipo_contrato',
      key: 'tipo_contrato',
      width: 150,
      render: (value) => tiposDeContratos.find((t) => t.id === value)?.descripcion,
    },
    {
      titleText: 'Espacio',
      dataIndex: 'espacio',
      key: 'espacio',
      width: 150,
      render: (value) => tiposDeEspacios.find((e) => e.id === value)?.descripcion,
    },
    {
      titleText: 'Medidas',
      dataIndex: 'medidas_lote',
      key: 'medidas_lote',
      width: 150,
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
  };

  const onClickAdd = () => {
    setIsCiudadano(false);
    setVisible(true);
  };

  const onClickEdit = async () => {
    setVisible(true);
    setLoading(true);
    const [key] = selectedRowKeys;
    const record = await getPanteon(key);
    const _isCiudadano = !record?.contributente;
    const padronId = _isCiudadano ? record.ciudadano : record.contributente?.id;
    let _padron = null;
    if (padronId) {
      _padron = await (_isCiudadano
        ? getCiudadano(padronId) : getContribuyente(padronId));
    }
    if (_padron) {
      if (_isCiudadano) {
        setCiudadanoFound([_padron]);
      } else {
        setContribuyenteFound([_padron]);
      }
    }
    // setCurrent(record);
    setIsCiudadano(_isCiudadano);
    setMutable(isMutable(record));
    form.setFieldsValue({
      ...record,
      tipo_de_padron: _isCiudadano ? padronesEnum.CIUDADANO : padronesEnum.CONTRIBUYENTE,
      [_isCiudadano ? 'ciudadano' : 'contribuyente']: padronId,
    });
    setLoading(false);
  };
  const onClickDelete = async () => {
    setVisibleAlert(true);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (!ciudadanoFound?.length && !contribuyenteFound?.length) {
        message.warn('Debe seleccionar un ciudadano o contribuyente');
        return;
      }

      if (isCiudadano) {
        const _ciuidadano = ciudadanoFound[0];
        values.ciudadano = _ciuidadano.id;
        values.apellido_materno_ciudadano = _ciuidadano.apellido_materno;
        values.apellido_paterno_ciudadano = _ciuidadano.apellido_paterno;
        values.ciudadano_nombre = _ciuidadano.nombre;
        values.nombre_completo_ciudadano = _ciuidadano?.nombre_completo
          || `${_ciuidadano
            ?.nombre || ''} ${_ciuidadano
            ?.apellido_paterno || ''} ${_ciuidadano
            ?.apellido_materno || ''}`.trim();
        delete values.contribuyente;
      } else {
        values.contributente = contribuyenteFound[0].id;
        delete values.ciudadano;
      }
      const saved = await (key ? patchPanteon(key, values) : postPanteon(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const resetAndValidate = () => {
    const fields = ['q, ciudadano, contribuyente'];
    form.resetFields(fields);
    form.validateFields(fields);
    setCiudadanoFound([]);
    setContribuyenteFound([]);
  };

  const rules = {
    required: [{ required: true }],
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deletePanteon(key);
    if (deleted) {
      setVisibleAlert(false);
      onCancel();
      await fetchData();
    }
    setLoading(false);
  };

  const asignarEntidad = async (user) => {
    setLoading(true);
    const { razon_social } = _entidad;
    const { entidad, nombre_completo, id } = user;
    entidad.push(entidad.id);
    await patchCiudadano(
      id,
      { entidad },
      `Ahora el usuario ${nombre_completo} también pertenece a ${razon_social}.`,
    );
    setLoading(false);
  };

  const msgAsignarEntidad = (user) => (
    message.info({
      content: (
        <>
          <Row style={{ width: '100%' }}>
            El ciudadano no pertenece a la entidad.
          </Row>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              ¿Desea asignarlo a esta entidad?
            </strong>
          </Row>
          <Row align="middle" justify="center" style={{ width: '100%' }}>
            <Button
              type="link"
              onClick={() => asignarEntidad(user)}
            >
              Si
            </Button>
            <Button
              onClick={() => {
                message.destroy();
                form.resetFields();
              }}
              type="link"
            >
              No
            </Button>
          </Row>
        </>

      ),
      duration: 0,
    })
  );

  const searchCiudadano = async () => {
    try {
      const { ciudadano_publico_en_general } = _entidad;
      setLoading(true);

      await form.validateFields(['q']);
      const { q } = form.getFieldsValue(['q']);

      if (!q) return;

      const _ciudadanos = await getCiudadanoCaja({ q });
      const { results = [] } = _ciudadanos || {};

      if (results.length === 0) {
        message.info('No se encontró ciudadano');
      } else if (results.length > 1) {
        setDataExterno(_ciudadanos);
        setVisibleBusquedaPadrones(true);
      } else {
        const [selected] = results;
        if (selected.id === ciudadano_publico_en_general) {
          message.info('No se puede asignar ciudadano público en general');
        } else {
          form.setFieldsValue({ ciudadano: selected.id });
          setCiudadanoFound([selected]);
        }
      }
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const searchContribuyente = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q } = form.getFieldsValue(['q']);
      if (q) {
        const _contribuyente = await getContribuyenteCaja({ q });
        if (_contribuyente?.results?.length === 1) {
          const [selected] = _contribuyente.results;
          form.setFieldsValue({ contribuyente: selected.id });
          setContribuyenteFound([selected]);
        } else if (_contribuyente.results.length > 1) {
          setDataExterno(_contribuyente);
          setVisibleBusquedaPadrones(true);
        } if (!_contribuyente.results.length) {
          message.info('No se encontró contribuyente');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const wipe = () => {
    formSearch.resetFields();
    setData({ results: [] });
  };

  const handleSearchData = async () => {
    try {
      setLoading(true);
      setSelectedRowKeys([]);
      await formSearch.validateFields();
      const searchParams = formSearch.getFieldsValue();
      const keys = Object.keys(searchParams);
      const validProps = keys.filter((prop) => searchParams[prop]);

      if (!validProps?.length) {
        message.warn('Debe ingresar al menos un campo.');
        return;
      }

      const _data = await getPanteones({ ...searchParams, page: 1 });
      setData(_data);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const debouncedSearch = () => {
    if (searchRef.current) {
      clearTimeout(searchRef.current);
    }
    searchRef.current = setTimeout(handleSearchData, 500);
  };

  const fillWithZero = ({ target: { value } }) => {
    if (!value) return;
    if (value.includes('.') && value.length < 13) {
      const [integer, decimal] = value.split('.');
      const fill = '0'.repeat(13 - (integer.length + decimal.length));
      formSearch.setFieldsValue({ folio: `${integer}${fill}${decimal}` });
    }
  };

  return (
    <Row justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible ? (
          <>
            <Form
              layout="vertical"
              form={formSearch}
              scrollToFirstError
              onFinish={() => debouncedSearch()}
            >
              <Row gutter={10}>
                <Col md={8} sm={24} xs={24}>
                  <Form.Item
                    label="Clave"
                    name="folio"
                    normalize={capitalize}
                  >
                    <Input allowClear onBlur={fillWithZero} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="contributente__nombre_completo"
                    label="Contribuyente (usar nombre completo)"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="panteon"
                    label="Panteón"
                    hasFeedback
                  >
                    <Select dataSource={tiposDePanteones} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_contrato"
                    label="Contrato"
                    hasFeedback
                  >
                    <Select disabled={!mutable} dataSource={tiposDeContratos} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="espacio"
                    label="Espacio"
                    hasFeedback
                  >
                    <Select dataSource={tiposDeEspacios} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="manzana"
                    label="Manzana"
                    hasFeedback
                  >
                    <Input disabled={!mutable} allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="seccion"
                    label="Sección"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="poliza"
                    label="Póliza"
                    hasFeedback
                  >
                    <Input disabled={!mutable} allowClear />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Button
                    htmlType="submit"
                    block
                    icon={<SearchOutlined />}
                  >
                    Buscar
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button
                    onClick={wipe}
                    block
                    icon={<DeleteOutlined />}
                  >
                    Limpiar Busqueda
                  </Button>
                </Col>
              </Row>
            </Form>
            <br />
            <Table
              cols={columns}
              data={data?.results || data}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit,
                onClickDelete,
              }}
              rowKey="id"
              baseURI={baseURI}
              hasAllViewPermission={permission.hasAllViewPermission}
              allowImport
              count={data.count}
              mobileColIndex={0}
              allowColumnSelector={false}
              permission={permission}
              pagination={false}
              paginationCallback={fetchData}
              currentPage={currentPage}
            />
          </>
        ) : (
          <Col span={24}>
            <Card
              className="form-container"
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} pantéon`}
              extra={(
                <FormSubmitControls
                  onFinish={onFinish}
                  onCancel={onCancel}
                  mutable={mutable}
                  allowSaveAndContinue
                  permission={permission}
                />
              )}
              bordered={false}
            >
              <Form
                name="general"
                layout="vertical"
                form={form}
                onFinish={() => onFinish()}
                scrollToFirstError
                initialValues={{
                  estados_globales: 1,
                  tipo_de_padron: padronesEnum.CONTRIBUYENTE,
                }}
              >
                <Row gutter={10}>
                  {!!selectedRowKeys.length && (
                  <>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="folio"
                        label="Folio"
                        hasFeedback
                        allowClear
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </>
                  )}
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_de_padron"
                      label="Tipo de padrón"
                      hasFeedback
                      rules={rules.required}
                    >
                      <Select
                        dataSource={padrones
                          .filter((padron) => [padronesEnum.CONTRIBUYENTE, padronesEnum.CIUDADANO]
                            .includes(padron.id))}
                        onChange={(value) => {
                          const _isCiudadano = value === padronesEnum.CIUDADANO;
                          setIsCiudadano(_isCiudadano);
                          setCiudadanoFound([]);
                          setContribuyenteFound([]);
                          if (ciudadanoFound.length || contribuyenteFound.length) {
                            message.info(`Se ha limpiado el campo ${!_isCiudadano ? 'Ciudadano' : 'Contribuyente'} si quiere conservar el valor, no guarde el registro.`);
                          }
                        }}
                        disabled={!mutable}
                      />
                    </Form.Item>
                  </Col>
                  <InputSearchPro
                    disabled={!mutable}
                    tooltip={isCiudadano ? 'Búsqueda de Ciudadano' : 'Búsqueda de Contribuyente'}
                    label={isCiudadano ? 'Búsqueda de Ciudadano' : 'Búsqueda de Contribuyente'}
                    name="q"
                    rules={rules.required}
                    onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                    breakPoints={{ xs: 24, sm: 24, md: 16 }}
                    inputProps={{
                      onPressEnter: () => (isCiudadano ? searchCiudadano() : searchContribuyente()),
                      onChange: ({ target: { value } }) => { if (!value) resetAndValidate(); },
                    }}
                    resultProps={{
                      name: isCiudadano ? 'ciudadano' : 'contribuyente',
                      label: isCiudadano ? 'Ciudadano' : 'Contribuyente',
                      dataSource: isCiudadano ? ciudadanoFound : contribuyenteFound,
                      onClear: resetAndValidate,
                      breakPoints: { xs: 24, sm: 24, md: 16 },
                      render: (item) => padronToString(item, isCiudadano
                        ? padronesEnum.CIUDADANO : padronesEnum.CONTRIBUYENTE),
                      keyProp: 'clave',
                    }}
                  />
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="panteon"
                      label="Panteón"
                      hasFeedback
                      rules={rules.required}
                    >
                      <Select disabled={!mutable} dataSource={tiposDePanteones} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_contrato"
                      label="Contrato"
                      hasFeedback
                      rules={rules.required}
                    >
                      <Select disabled={!mutable} dataSource={tiposDeContratos} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="espacio"
                      label="Espacio"
                      hasFeedback
                      rules={rules.required}
                    >
                      <Select disabled={!mutable} dataSource={tiposDeEspacios} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_de_compra"
                      label="Fecha de compra"
                      hasFeedback
                    >
                      <DatePicker
                        disabled={!mutable}
                        format={DATETIME_FRONTEND_FORMAT}
                        showTime
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="medidas"
                      label="Medidas"
                      hasFeedback
                    >
                      <Select disabled={!mutable} dataSource={medidas} />
                    </Form.Item>
                  </Col> */}
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="medidas_lote"
                      label="Medidas"
                      hasFeedback
                    >
                      <Input disabled={!mutable} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="estados_globales"
                      label="Estado"
                      hasFeedback
                    >
                      <Select
                        disabled={!mutable || !selectedRowKeys.length}
                        dataSource={estadosGlobales}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={10} justify="space-between">
                  <Col xs={24} sm={24} md={5}>
                    <Form.Item
                      name="lote"
                      label="Lote"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                  {/*
                  <Col span={4}>
                    <Form.Item
                      name="registro"
                      label="Registro"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name="certificado"
                      label="Certificado"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                      */}
                  <Col xs={24} sm={24} md={4}>
                    <Form.Item
                      name="cantidad"
                      label="Cantidad"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                  {/*
                  <Col span={4}>
                    <Form.Item
                      name="linea"
                      label="Línea"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      name="cuadro"
                      label="Cuadro"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                    */}
                  {/*
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      name="frente_vuelta"
                      label="¿Frente o Vuelta?"
                      hasFeedback
                    >
                      <Select
                        disabled={!mutable}
                        dataSource={[
                          { id: true, descripcion: 'Frente' },
                          { id: false, descripcion: 'Vuelta' },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  */}
                  <Col xs={24} sm={24} md={4}>
                    <Form.Item
                      name="poliza"
                      label="Póliza"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={4}>
                    <Form.Item
                      name="manzana"
                      label="Manzana"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={4}>
                    <Form.Item
                      name="seccion"
                      label="Sección"
                      hasFeedback
                    >
                      <Input disabled={!mutable} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={16}>
                    <Form.Item
                      name="observaciones"
                      label="Observaciones"
                      hasFeedback
                      normalize={capitalize}
                    >
                      <Input.TextArea
                        autoSize={{ minRows: 3, maxRows: 3 }}
                        allowClear
                        disabled={!mutable}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Form>
              {/*! !selectedRowKeys.length && (
                <Difuntos
                  panteon={current}
                  permission={permissionsDifuntos}
                />
              ) */}
            </Card>
          </Col>
        )}
      </Spin>
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => setVisibleAlert(false)}
        visible={visibleAlert}
        content="panteón seleccionado"
        loading={loading}
      />
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPadrones}
        setVisible={setVisibleBusquedaPadrones}
        callback={(found) => {
          if (isCiudadano) {
            setCiudadanoFound([found]);
            form.setFieldsValue({ ciudadano: found.id });
          } else {
            setContribuyenteFound([found]);
            form.setFieldsValue({ contribuyente: found.id });
          }
        }}
        dataExterno={dataExterno}
        setDataExterno={setDataExterno}
        tipoDePadron={isCiudadano ? 1 : 15}
        msgAsignarEntidad={msgAsignarEntidad}
        allowAdd={false}
      />
    </Row>
  );
};

Panteones.propTypes = {
  permission: PropTypes.shape({
    hasAllViewPermission: PropTypes.bool,
    viewcrud: PropTypes.bool,
    view: PropTypes.bool,
    add: PropTypes.bool,
    change: PropTypes.bool,
    delete: PropTypes.bool,
    authorize: PropTypes.bool,
    cancel: PropTypes.bool,
    export: PropTypes.bool,
    import: PropTypes.bool,
    sync: PropTypes.bool,
    model: PropTypes.string,
  }).isRequired,
};

export default Panteones;
